import { generateModuleStore } from "@/shared/lib";

const namespace = "vacancies";

const module = generateModuleStore({
  namespace,
  filterName: "name",
});

export { namespace, module };
